import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useAccount } from '../contexts/AccountContext';
import { firestore } from '../services/firebase';
import type { UserAction } from '../types/action';

export const useUserActions = () => {
  const { account } = useAccount();
  const [userActions, setUserActions] = useState<UserAction[]>([]);
  const [isLoadingActions, setIsLoadingActions] = useState(true);
  const [actionsError, setActionsError] = useState<string | null>(null);

  useEffect(() => {
    if (!account?.uid) {
      setUserActions([]);
      setIsLoadingActions(false);
      return;
    }

    setIsLoadingActions(true);
    setActionsError(null);

    const actionsRef = collection(firestore, 'users', account.uid, 'actions');
    const q = query(actionsRef, where('status', '==', 'pending'));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const actions = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as UserAction[];
        setUserActions(actions);
        setIsLoadingActions(false);
      },
      (error) => {
        setActionsError(error.message);
        setIsLoadingActions(false);
      }
    );

    return () => unsubscribe();
  }, [account?.uid]);

  return { userActions, isLoadingActions, actionsError };
};
